export var makeHomeController = function () {
    var s = {
        init: function () {
            s.initAnimatedScroll();
        },
        initAnimatedScroll: function () {
            var scrollElements = document.querySelectorAll(".js-scroll");
            var elementInView = function (el, dividend) {
                if (dividend === void 0) { dividend = 1; }
                var elementTop = el.getBoundingClientRect().top;
                return (elementTop <= (window.innerHeight || document.documentElement.clientHeight) / dividend);
            };
            var displayScrollElement = function (element) {
                element.classList.add("visible");
            };
            var handleScrollAnimation = function () {
                scrollElements.forEach(function (el) {
                    if (elementInView(el, 1.25)) {
                        displayScrollElement(el);
                    }
                });
            };
            window.addEventListener("scroll", function () {
                handleScrollAnimation();
            });
            handleScrollAnimation();
        },
    };
    return s;
};
var HomeController = makeHomeController();
export default HomeController;
